"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebouncedTextInput = void 0;
var _alloyReactTextInput = _interopRequireDefault(require("@adsk/alloy-react-text-input"));
var _react = _interopRequireWildcard(require("react"));
var _useLocalizedDecimalSeparator = require("../../hooks/useLocalizedDecimalSeparator");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const useDebouncedValue = function (originalValue) {
  let originalOnChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  let wait = arguments.length > 2 ? arguments[2] : undefined;
  let isNumeric = arguments.length > 3 ? arguments[3] : undefined;
  let setError = arguments.length > 4 ? arguments[4] : undefined;
  const [value, setValue] = (0, _react.useState)(originalValue);
  const timeoutRef = (0, _react.useRef)(null);
  const {
    getLocalizedDecimalSeparator
  } = (0, _useLocalizedDecimalSeparator.useLocalizedDecimalSeparator)();
  const decimalSeparator = (0, _react.useMemo)(() => getLocalizedDecimalSeparator(), [getLocalizedDecimalSeparator]);

  // filter input has no validation beyond alloy's textInput validation
  // the built in validation ignores alphabet characters if given the "number" type, but that disallows custom decimal separators
  // the filters form has no error message functionality so no error message is displayed
  const shouldIgnoreNumericValueUpdate = (0, _react.useCallback)((value, isNumericField) => {
    if (!isNumericField || !value) {
      return false;
    }

    // different regex than the one in validationUtils because it has to allow inserting of additional numberic character after the decimal separator
    // (number is validated after every key stroke)
    const regexp = new RegExp("^[-]?[0-9]+(\\".concat(decimalSeparator, "[0-9]*)?$"), "g");
    return !regexp.test(value);
  }, [decimalSeparator]);
  const onChange = (0, _react.useCallback)(e => {
    if (shouldIgnoreNumericValueUpdate(e.target.value, isNumeric)) {
      setError(true);
      return;
    }
    setValue(e.target.value);
    setError(false);
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      originalOnChange(e);
    }, wait);
  }, [shouldIgnoreNumericValueUpdate, isNumeric, wait, setError, originalOnChange]);
  return [value, onChange];
};
const DebouncedTextInput = exports.DebouncedTextInput = _react.default.forwardRef((_ref, ref) => {
  let {
    onChange: originalOnChange,
    value: originalValue,
    isNumeric,
    ...props
  } = _ref;
  const [error, setError] = (0, _react.useState)(false);
  const [value, onChange] = useDebouncedValue(originalValue, originalOnChange, 1000, isNumeric, setError);
  return /*#__PURE__*/_react.default.createElement(_alloyReactTextInput.default
  // @ts-ignore
  , _extends({
    ref: ref
  }, props, {
    value: value,
    onChange: onChange,
    error: error
  }));
});
//# sourceMappingURL=DebouncedTextInput.js.map